import { isContainingTag } from './isContainingTag';
import { pathForTag } from './pathForTag';

export const filterTagsByManyTags = (currentlyTags = [], selectedTags = []) =>
  currentlyTags.filter(
    currentlyTag => !isContainingTag(selectedTags, currentlyTag),
  );

export const filterTagsByOneTag = (tagList, { id, value }) =>
  tagList.filter(tagItem => {
    // filter by id
    if (tagItem.id || id) {
      return tagItem.id !== id;
    }

    // filter by value
    return !(tagItem.value === value);
  });

export const filterTagGroup = (filterValue, tags, selectionTags) => {
  const viaInput = tags?.filter(tag =>
    pathForTag(tag).toLowerCase().includes(filterValue.toLowerCase()),
  );
  const viaSelectedTags = filterTagsByManyTags(viaInput, selectionTags);

  return viaSelectedTags;
};
